import AppConfig from "../../config/AppConfig";

const createTracking = () => {
  return {
    identify(email) {
      if (AppConfig.ENABLE_SEGMENT) {
        //analytics.identify(email);
      }
    },
    track(data) {
      if (AppConfig.ENABLE_SEGMENT) {
        //analytics.track(data);
      }
    },
    screen(name, data) {
      if (AppConfig.ENABLE_SEGMENT) {
        if (true) { //typeof analytics.page !== "undefined") {
          //analytics.page(name, data);
        } else {
          //analytics.screen(name, data);
        }
      }
    },
    setup(key) {
      if (AppConfig.ENABLE_SEGMENT) {
        return true; //analytics.setup(key);
      }
    },
  };
};

export default createTracking();
